import React, { useState, useRef } from 'react';
import Chart from "react-apexcharts";
import Part2 from './part2';
import Part3 from './part3';
import CalculationInput from '../../calculation-input';
import { logEvent } from '@firebase/analytics';
import {analytics} from '../../../config/firebase-logging';

function Forecast() {

  const options = {
    chart: {
      height: 350,

    },
    title: {
      text: 'Revenue (in millions) vs Time',
      align: 'left',
      style: {
        fontSize: "16px",
        color: '#666'
      }
    },
    fill: {
      type: 'solid',
    },
    markers: {
      size: [6, 8]
    },
    tooltip: {
      followCursor: true,
    },
    legend: {
      show: false
    },
    xaxis: {
      format: "yyyy",
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return "$" + value;
        }
      },
    }
  }
  const defaultScatterPlot = {
    name: 'Points',
    type: 'scatter',
    data: [[2015, 2000000], [2016, 3500000], [2017, 4750000], [2018, 5500000], [2019, 6000000], [2020, 6480000], [2021, 7390000], [2022, 9300000]]
  }
  const linearCustomerDemand = {
    name: 'Line',
    type: 'line',
    data: [[2015, 2438333], [2022, 8791666]]
  }
  const linearMarketGrowth = {
    name: 'Line',
    type: 'line',
    data: [[2015, 2000333], [2022, 6904666]]
  }
  const linearEconomicConditions = {
    name: 'Line',
    type: 'line',
    data: [[2015, 3000333], [2022, 7904666]]
  }
  const logMarketGrowth = {
    name: 'Line',
    type: 'line',
    data: [[2015, 1300619], [2016, 2687280], [2017, 3498425], [2018, 4073941], [2019, 4520346], [2020, 4885086], [2021, 5193469], [2022, 5460602]]
  }
  const logCustomerDemand = {
    name: 'Line',
    type: 'line',
    data: [[2015, 1515619], [2016, 3659197], [2017, 4913110], [2018, 5802775], [2019, 6492853], [2020, 7056687], [2021, 7533403], [2022, 7946352]]
  }
  const logEconomic = {
    name: 'Line',
    type: 'line',
    data: [[2015, 800495], [2016, 2353438], [2017, 3261852], [2018, 3906381], [2019, 4406317], [2020, 4814795], [2021, 5160158], [2022, 5459324]]
  }
  const polynomialMarketGrowth = {
    name: 'Line',
    type: 'line',
    data: [[2015, 1993409.1], [2016, 3535643.8], [2017, 4747078.5], [2018, 5512513.2], [2019, 5831947.9], [2020, 5820582.6], [2021, 5708817.3], [2022, 5842252]]
  }
  const polynomialCustomerDemand = {
    name: 'Line',
    type: 'line',
    data: [[2015, 1993409.1], [2016, 3525573.6], [2017, 4717586.9], [2018, 5509147.2], [2019, 6006771.9], [2020, 6483797.6], [2021, 7380380.1], [2022, 9802494.4], [2023, 13026934.7], [2024, 19491314.4]]
  }
  const polynomialEconomic = {
    name: 'Line',
    type: 'line',
    data: [[2015, 1993409.1], [2016, 3516573.6], [2017, 4645586.9], [2018, 5266147.2], [2019, 5430771.9], [2020, 5358797.6], [2021, 5436380.1], [2022, 6216494.4]]
  }
  const [slide, setSlide] = useState(1);
  const [chartValue, setChartValue] = useState({
    series: [defaultScatterPlot],
    options: {
      ...options,
    }
  });

  function nextSlide() {
    setSlide(slide + 1);
  }

  function onPart2Finish() {
    setChartValue({
      series: [defaultScatterPlot, linearMarketGrowth],
      options: {
        ...options,
      }
    })
  }

  function part2Reset() {
    setChartValue({
      series: [defaultScatterPlot],
      options: {
        ...options,
      }
    })
  }

  function displayModel(modelIndex, varIndex) {
    // Linear
    if (modelIndex === 0) {
      if (varIndex === 3) {
        setChartValue({
          series: [defaultScatterPlot, linearMarketGrowth],
          options: {
            ...options,
          }
        })
        return;
      }
      if (varIndex === 4) {
        setChartValue({
          series: [defaultScatterPlot, linearCustomerDemand],
          options: {
            ...options,
          }
        })
        return;
      }
      if (varIndex === 5) {
        setChartValue({
          series: [defaultScatterPlot, linearEconomicConditions],
          options: {
            ...options,
          }
        })
        return;
      }
    }
    // Logarithmic
    if (modelIndex === 1) {
      if (varIndex === 3) {
        setChartValue({
          series: [defaultScatterPlot, logMarketGrowth],
          options: {
            ...options,
          }
        })
        return;
      }
      if (varIndex === 4) {
        setChartValue({
          series: [defaultScatterPlot, logCustomerDemand],
          options: {
            ...options,
          }
        })
        return;
      }
      if (varIndex === 5) {
        setChartValue({
          series: [defaultScatterPlot, logEconomic],
          options: {
            ...options,

          }
        })
        return;
      }
    }
    // Polynomial
    if (modelIndex === 2) {
      if (varIndex === 3) {
        setChartValue({
          series: [defaultScatterPlot, polynomialMarketGrowth],
          options: {
            ...options,
          }
        })
        return;
      }
      if (varIndex === 4) {
        setChartValue({
          series: [defaultScatterPlot, polynomialCustomerDemand],
          options: {
            ...options,
          }
        })
        return;
      }
      if (varIndex === 5) {
        setChartValue({
          series: [defaultScatterPlot, polynomialEconomic],
          options: {
            ...options,
          }
        })
        return;
      }
    }
  }

  function showAccuracy(modelIndex, varIndex) {
    // Linear
    if (modelIndex === 0) {
      if (varIndex === 3) {
        return "80.38%";
      }
      if (varIndex === 4) {
        return "96.29%"
      }
      if (varIndex === 5) {
        return "72.34%"
      }
    }
    // Logarithmic
    if (modelIndex === 1) {
      if (varIndex === 3) {
        return "60.35%";
      }
      if (varIndex === 4) {
        return "84.19%"
      }
      if (varIndex === 5) {
        return "62.83%"
      }
    }
    // Polynomial
    if (modelIndex === 2) {
      if (varIndex === 3) {
        return "75.94%";
      }
      if (varIndex === 4) {
        return "98.97%"
      }
      if (varIndex === 5) {
        return "75.77%"
      }
    }

  }


  return (
    <div>
      {slide === 1 && (
        <>
          <p>In addition to analysis, it's a common task for financial analysts to do forecasting. What is forecasting?</p>
          <p>
            Forecasting is the process of making predictions about future business performance based on historical data and market trends. Financial analysts use various techniques to predict financial metrics such as revenue, expenses, cash flow, and earnings. Accurate forecasting can help businesses to anticipate potential challenges and opportunities, and make timely adjustments to their strategies.
          </p>
          <p>For this exercise, we will forecast EcoGreen Technologies' revenue over time. Though our income statement has revenue for the last 3 years, it's not  enough data to make a significant prediction. You have been provided with EcoGreen's revenue from back until 2015. The data is represented in the scatterplot below.</p>
          <button className='primary-btn' onClick={() => {
            if (process.env.REACT_APP_ENVIRONMENT === "production") {
              logEvent(analytics, 'career_interaction')
            }
            nextSlide();
          }}>Continue</button>
        </>
      )}
      {slide === 2 && (
        <Part2 onPart2Finish={onPart2Finish} nextSlide={nextSlide} part2Reset={part2Reset} />
      )}
      {slide === 3 && (
        <Part3 showAccuracy={showAccuracy} displayModel={displayModel} nextSlide={nextSlide}/>
      )}
      {slide === 4 && (
        <>
          <p>Now we need to use our model to actually make a prediction. Predict EcoGreen's revenue in 2024.</p>
          <CalculationInput ans={19491314.4} successMessage="Nice job!" failureMessage="Not quite! Try again"/>
        </>
      )}




      <div className='row' style={{ justifyContent: "center" }}>
        <Chart
          options={chartValue.options}
          series={chartValue.series}
          width="1000"
        />
      </div>

    </div>
  )


}

export default Forecast;